import { render } from "./Access.vue?vue&type=template&id=03a2a4f2&scoped=true"
import script from "./Access.vue?vue&type=script&lang=js"
export * from "./Access.vue?vue&type=script&lang=js"

import "./Access.vue?vue&type=style&index=0&id=03a2a4f2&scoped=true&lang=css"

import exportComponent from "/workspace/wum/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03a2a4f2"]])

export default __exports__